module.exports = __webpack_public_path__ + "static/hyperv_26.0344ab15.jpg";